import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Input, Pagination, Table } from "antd";
import { useEffect, useState } from "react";
import { useDebounce } from "../../hooks/useDebounce";

const CustomTable = ({
  data,
  columns,
  buttonVisible,
  searchVisible,
  fetchData,
  isLoading,
  totalData,
  pageLimitOptions = ["10", "25", "50", "100"],
  currentPage,
  rowsPerPage,
  onPageChange,
  buttonClick,
  importButtonVisible,
  searchLabel,
  enableRowClick = false,
  onRowClick,
  onSearchChange,
  onSearch,
  buttonTitle,
  reRenderFlag, // New prop for re-render flag
  startEntry,
  endEntry,
  extraComponent,
  paginationShow,
}: any) => {
  const [search, setSearch] = useState("");
  const [sorter, setSorter] = useState({ field: null, order: null });
  const debouncedSearch = useDebounce(search, 700);

  useEffect(() => {
    fetchData(
      currentPage,
      rowsPerPage,
      debouncedSearch,
      sorter.field,
      sorter.order,
    );
  }, [currentPage, rowsPerPage, debouncedSearch, sorter, reRenderFlag]); // Add reRenderFlag to dependencies

  const handleSearchChange = (e: any) => {
    onSearch();
    setSearch(e.target.value);
    onSearchChange(e.target.value);
  };

  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    const order: any =
      sorter.order === "ascend"
        ? "ASC"
        : sorter.order === "descend"
          ? "DESC"
          : null;

    const sortField = Array.isArray(sorter.field)
      ? sorter.field.join(".")
      : sorter.field;

    setSorter({
      field: sortField,
      order: order,
    });
  };

  // const handleExport = () => {
  //   // const exportData = data.map((row: any) => {
  //   //   const newRow: any = {};
  //   //   columns.forEach((col: any) => {
  //   //     if (col.dataIndex && col.title) {
  //   //       newRow[col.title] = row[col.dataIndex];
  //   //     }
  //   //   });
  //   //   return newRow;
  //   // });
  //   // const worksheet = XLSX.utils.json_to_sheet(exportData);
  //   // const workbook = XLSX.utils.book_new();
  //   // XLSX.utils.book_append_sheet(workbook, worksheet, "Member Data");
  //   // XLSX.writeFile(workbook, "member_data.xlsx");
  // };

  const renderSerialNumber = (text: any, record: any, index: any) => {
    return (currentPage - 1) * rowsPerPage + index + 1;
  };

  const modifiedColumns = columns.map((col: any) => {
    if (col.key === "no") {
      return {
        ...col,
        render: renderSerialNumber,
      };
    }

    return col;
  });

  return (
    <>
      {(searchVisible || buttonVisible || extraComponent) && (
        <div className="mb-4 flex justify-end items-center gap-4 w-full">
          {searchVisible && (
            <Input
              placeholder={searchLabel}
              value={search}
              className="max-w-[250px] py-[6px]"
              onChange={handleSearchChange}
              prefix={
                search ? (
                  <Button
                    icon={<CloseOutlined />}
                    className="mr-2 h-6 !w-6"
                    onClick={() => {
                      setSearch("");
                      onSearchChange("");
                    }}
                  />
                ) : (
                  <SearchOutlined className="mr-2" />
                )
              }
            />
          )}
          {buttonVisible && (
            <button
              className="bg-[#00A48B] text-white font-medium py-2 px-5 rounded-md text-sm"
              onClick={buttonClick}
            >
              {buttonTitle}
            </button>
          )}
          {importButtonVisible && (
            <button
              className="bg-[#00A48B] text-white font-medium py-2 px-5 rounded-md text-sm"
              onClick={buttonClick}
            >
              Import
            </button>
          )}
          {extraComponent && extraComponent}
        </div>
      )}
      <Table
        columns={modifiedColumns}
        dataSource={Array.isArray(data) ? data : []}
        rowKey="id"
        loading={isLoading}
        pagination={false}
        onChange={handleTableChange}
        onRow={
          enableRowClick
            ? (record) => ({
                onClick: () => onRowClick(record),
              })
            : undefined
        }
        className={`${enableRowClick ? "cursor-pointer" : ""}`}
        locale={{ emptyText: "No data available" }}
      />
      <div className="flex justify-between items-center mt-4">
        {paginationShow && totalData > 0 && (
          <>
            <span>
              {`Showing entries from ${startEntry} to ${endEntry} of ${totalData}`}
            </span>
            <Pagination
              current={currentPage}
              pageSize={rowsPerPage}
              total={totalData}
              onChange={onPageChange}
              showSizeChanger
              pageSizeOptions={pageLimitOptions}
            />
          </>
        )}
      </div>
    </>
  );
};

export default CustomTable;
